import InteractionIntervalSetting from "../models/communications/InteractionIntervalSetting";
import Condition from "../models/conditions/Condition";
import Interaction from "../models/interactions/Interaction";
import InteractionNode from "../models/interactions/InteractionNode";
import { Immutable } from "./Util";

export enum draggable_types {
  Condition = "Condition",
  Interaction = "Interaction",
}

export class ConditionDragItem {
  conditionID: number;
  index: number;
  parentID: number | null;

  constructor(conditionID: number, index: number, parentID: number | null) {
    this.conditionID = conditionID;
    this.index = index;
    this.parentID = parentID;
  }
}

export class InteractionNodeDragItem {
  node: InteractionNode;
  interaction: Interaction;
  index: number;
  parent?: InteractionNode | null | undefined;
  interactionIntervalSettings?: Array<InteractionIntervalSetting> | undefined;
  intervalSetID?: number | undefined;

  constructor(
    node: InteractionNode,
    interaction: Interaction,
    index: number,
    parent?: InteractionNode | null | undefined,
    interactionIntervalSettings?: Array<InteractionIntervalSetting> | undefined,
    intervalSetID?: number | undefined,
  ) {
    this.node = node;
    this.interaction = interaction;
    this.index = index;
    this.parent = parent;
    this.interactionIntervalSettings = interactionIntervalSettings;
    this.intervalSetID = intervalSetID;
  }
}
